<template>
<div class="CreateMessage">
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
  <div class="text">
    <p>Please wait, saving document.</p>
  </div>
</div>
</template>

<script>
export default {
  name: "CreateMessage"
}
</script>

<style lang="scss">

.CreateMessage {
  padding: 120px 0 90px;
  text-align: center;

  .text {
    text-align: center;
    color: #320d57;
    font-size: 23px;
    margin-bottom: 46px;

    p {
      margin: 0;
    }
  }
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  margin-bottom: 27px;

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid #9e9e9e;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #9e9e9e transparent transparent transparent;

    &:nth-child(1) {
      animation-delay: -0.45s;
    }

    &:nth-child(2) {
      animation-delay: -0.3s;
    }

    &:nth-child(3) {
      animation-delay: -0.15s;
    }
  }
}
</style>
